import { apiSlice } from "./api";

export interface RunDatabaseIntegrityChecksRequest {
  fixErrors: boolean;
}
export interface RunDatabaseIntegrityChecksResponse {
  errorsFound: boolean;
  errorMessage: string;
}

export const systemApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    runDatabaseIntegrityChecks: builder.mutation<
      RunDatabaseIntegrityChecksResponse,
      RunDatabaseIntegrityChecksRequest
    >({
      query: (body) => ({
        url: "runDatabaseIntegrityChecksAdmin",
        body: JSON.stringify(body),
      }),
    }),
  }),
});

export const { useRunDatabaseIntegrityChecksMutation } = systemApi;
